// @ts-nocheck
import type { RewardTier } from '../types/gamification';

/**
 * Conservative reward option from the PRD.
 * Mileage: monthly, 13 months through first renewal.
 */
export const MILEAGE_REWARDS: RewardTier[] = [
  { ordinal: 1, baseReward: 5, label: 'Activation' },
  { ordinal: 2, baseReward: 4, label: 'Welcome Series' },
  { ordinal: 3, baseReward: 3, label: 'Welcome Series' },
  { ordinal: 4, baseReward: 3 },
  { ordinal: 5, baseReward: 3 },
  { ordinal: 6, baseReward: 3, milestoneBonus: 8, label: '6-Month Milestone' },
  { ordinal: 7, baseReward: 3 },
  { ordinal: 8, baseReward: 3 },
  { ordinal: 9, baseReward: 3 },
  { ordinal: 10, baseReward: 4 },
  { ordinal: 11, baseReward: 4 },
  { ordinal: 12, baseReward: 4, milestoneBonus: 5, label: 'Pre-Renewal' },
  { ordinal: 13, baseReward: 4, milestoneBonus: 15, label: 'Renewal Bonus' },
];

/**
 * Condition: quarterly, 5 check-ins through first renewal.
 */
export const CONDITION_REWARDS: RewardTier[] = [
  { ordinal: 1, baseReward: 12, label: 'Activation' },
  { ordinal: 2, baseReward: 10 },
  { ordinal: 3, baseReward: 10, milestoneBonus: 5, label: '6-Month Milestone' },
  { ordinal: 4, baseReward: 10 },
  { ordinal: 5, baseReward: 10, milestoneBonus: 8, label: 'Renewal Bonus' },
];

/** Year 2+ defaults */
export const YEAR2_MILEAGE: RewardTier = { ordinal: 14, baseReward: 3, milestoneBonus: 15, label: 'Annual Renewal' };
export const YEAR2_CONDITION: RewardTier = { ordinal: 6, baseReward: 10, milestoneBonus: 8, label: 'Annual Renewal' };

/** Milestone ordinals for quick lookup */
export const MILEAGE_MILESTONES = new Set([6, 12, 13]);
export const CONDITION_MILESTONES = new Set([3, 5]);
